var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "marginTop card-body" },
    [
      _c("p", [_vm._v("Responda as perguntas abaixo para prosseguir:")]),
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { xl: 8, lg: 12 } }, [
            _c(
              "div",
              { staticClass: "question" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c("app-label", {
                            attrs: {
                              label:
                                "O título a ser permutado pertence ao Projeto Integrado Trairão ?",
                              required: true
                            }
                          }),
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "radio-group",
                              class: { erro: errors[0] },
                              attrs: { name: "pertenceAoProjeto" },
                              on: { change: _vm.clearSelectedGleba },
                              model: {
                                value:
                                  _vm.cadastro.qualificacao.pertenceAoProjeto,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.cadastro.qualificacao,
                                    "pertenceAoProjeto",
                                    $$v
                                  )
                                },
                                expression:
                                  "cadastro.qualificacao.pertenceAoProjeto"
                              }
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  staticClass: "radio",
                                  attrs: { label: true }
                                },
                                [_vm._v("Sim")]
                              ),
                              _c(
                                "el-radio",
                                {
                                  staticClass: "radio",
                                  attrs: { label: false }
                                },
                                [_vm._v("Não")]
                              )
                            ],
                            1
                          ),
                          _c("span", { staticClass: "help erro" }, [
                            _vm._v(_vm._s(errors[0]))
                          ])
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { xl: 8, lg: 10, sm: 12 } }, [
            _vm.cadastro.qualificacao.pertenceAoProjeto
              ? _c(
                  "div",
                  { staticClass: "question" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required", name: "Glebas" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-label", {
                                  attrs: {
                                    label:
                                      "Informe a gleba de localização da área de interesse:",
                                    required: true
                                  }
                                }),
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "input select",
                                    class: { erro: errors.length },
                                    attrs: {
                                      placeholder: "Selecione",
                                      "no-match-text":
                                        "Nenhuma gleba encontrada",
                                      filterable: "filterable",
                                      clearable: "clearable",
                                      name: "gleba",
                                      "value-key": "id"
                                    },
                                    model: {
                                      value: _vm.cadastro.qualificacao.gleba,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.cadastro.qualificacao,
                                          "gleba",
                                          $$v
                                        )
                                      },
                                      expression: "cadastro.qualificacao.gleba"
                                    }
                                  },
                                  _vm._l(_vm.glebas, function(item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: { label: item.nome, value: item }
                                    })
                                  }),
                                  1
                                ),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        909153937
                      )
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { lg: 12, sm: 24 } }, [
            _c(
              "div",
              { staticClass: "question" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c("app-label", {
                            attrs: {
                              label:
                                "O interessado é o beneficiário original ?",
                              required: true
                            }
                          }),
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "radio-group",
                              class: { erro: errors[0] },
                              attrs: { name: "beneficiarioOriginal" },
                              model: {
                                value:
                                  _vm.cadastro.qualificacao
                                    .beneficiarioOriginal,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.cadastro.qualificacao,
                                    "beneficiarioOriginal",
                                    $$v
                                  )
                                },
                                expression:
                                  "cadastro.qualificacao.beneficiarioOriginal"
                              }
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  staticClass: "radio",
                                  attrs: { label: true }
                                },
                                [_vm._v("Sim")]
                              ),
                              _c(
                                "el-radio",
                                {
                                  staticClass: "radio",
                                  attrs: { label: false }
                                },
                                [_vm._v("Não")]
                              )
                            ],
                            1
                          ),
                          _c("span", { staticClass: "help erro" }, [
                            _vm._v(_vm._s(errors[0]))
                          ])
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { lg: 12, sm: 24 } }, [
            _c(
              "div",
              { staticClass: "question" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c("app-label", {
                            attrs: {
                              label:
                                "O Valor da Terra Nua (VTN) foi pago integralmente ?",
                              required: true
                            }
                          }),
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "radio-group",
                              class: { erro: errors[0] },
                              attrs: { name: "pagoIntegral" },
                              model: {
                                value: _vm.cadastro.qualificacao.pagoIntegral,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.cadastro.qualificacao,
                                    "pagoIntegral",
                                    $$v
                                  )
                                },
                                expression: "cadastro.qualificacao.pagoIntegral"
                              }
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  staticClass: "radio",
                                  attrs: { label: true }
                                },
                                [_vm._v("Sim")]
                              ),
                              _c(
                                "el-radio",
                                {
                                  staticClass: "radio",
                                  attrs: { label: false }
                                },
                                [_vm._v("Não")]
                              )
                            ],
                            1
                          ),
                          _c("span", { staticClass: "help erro" }, [
                            _vm._v(_vm._s(errors[0]))
                          ])
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-591f3f93", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-591f3f93","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/para/permuta/components/Qualificacao.vue
// module id = null
// module chunks = 